import { render, staticRenderFns } from "./AliasNameYN.vue?vue&type=template&id=33c5dbbb"
import script from "./AliasNameYN.vue?vue&type=script&lang=js"
export * from "./AliasNameYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports